

$(document).on('click', function(event) {
let targetElementId = event.target.id;

if(targetElementId == "Search-In-Modal") {
let searchTermLengthModal = $('#Search-In-Modal').val().length;
if(searchTermLengthModal < 1) {
document.querySelector("#Search-In-Modal ~ .predictive-search--search-template").classList.add("close_searchh");
}
else {
document.querySelector("#Search-In-Modal ~ .predictive-search--search-template").classList.remove("close_searchh");            
}
console.log("Search-In-Modal", document.querySelector("#Search-In-Modal ~ .predictive-search--search-template"));
}
else {
document.querySelector("#Search-In-Modal ~ .predictive-search--search-template").classList.add("close_searchh");
}
});

// recent searches
$('#Search-In-Modal').keyup(function() {
var recent_value = $(this).val();
if(recent_value.length < 1) {
$('.search_arrow').css('opacity', '0');
}
else {
$('.search_arrow').css('opacity', '1');
if(recent_value.length >= 4) {
setTimeout(function() {
// console.log(recent_value,'recent_value');
}, 500);
}
}
});

var modal_search_input = document.getElementById('Search-In-Modal');

$('#Search-In-Modal').keyup(delay(function (e) {
// console.log('Time elapsed!', this.value);
}, 500));






$('#Search-In-Template').keyup(delay(function (e) {
// console.log('Time elapsed!', this.value);
}, 500));


function delay(callback, ms) {
var timer = 0;
return function() {
var context = this, args = arguments;
clearTimeout(timer);
timer = setTimeout(function () {
callback.apply(context, args);
var inputval = modal_search_input.value;

var get_handle = '/search?view=ajaxr&q='+ modal_search_input.value;

if(modal_search_input.value == ''){

}
else if(inputval.length >= 3 ) {
$.ajax({
url:get_handle,
type:'GET',
success: function(data){
var recenet_searches = [];
var recent_cookies = getCookie('recent_searches');
if(recent_cookies){
recenet_searches = recent_cookies.split(',');
}
recenet_searches.push(inputval);
let uniqueChars = recenet_searches.filter((c, index) => {
return recenet_searches.indexOf(c) === index;
});
recenet_searches = uniqueChars.join('+');
setCookie('recent_searches', recenet_searches , 7);

$('.recent-list-item').hide();
recenet_searches.split("+").forEach(function(row){

$(".recent-search-list").append("<li class='recent-list-item'>"+row+"</li>");
var seen = {};
$('.recent-list-item').each(function() {
var txt = $(this).text();
if (seen[txt])
$(this).remove();
else
seen[txt] = true;
});
setTimeout(function(){
$('ul.recent-search-list li').removeClass('last');
$('ul.recent-search-list li:nth-last-child(4)').addClass('last');
$('ul.recent-search-list li:nth-last-child(3)').addClass('last');
$('ul.recent-search-list li:nth-last-child(2)').addClass('last');
$('ul.recent-search-list li:nth-last-child(1)').addClass('last');
$('ul.recent-search-list li').each(function(){
if(!$(this).hasClass('last')){
$(this).remove();
}
})
var list = $('ul.recent-search-list');
var listItems = list.children('li');
list.append(listItems.get());
},500);
});
}
});
}





}, ms || 0);
};
}

function onlyUnique(value, index, self) {
return self.indexOf(value) === index;
}

function setCookie(name, value, days) {
var expires = "";
if (days) {
var date = new Date();
date.setTime(date.getTime() + (days*24*60*60*1000));
expires = "; expires=" + date.toUTCString();
}
document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
// get cookies
function getCookie(name) {
var nameEQ = name + "=";
var ca = document.cookie.split(';');
for(var i=0;i < ca.length;i++) {
var c = ca[i];
while (c.charAt(0)==' ') c = c.substring(1,c.length);
if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
}
return null;
}
